import type { ReactNode, ForwardedRef } from 'react';
import { forwardRef, CSSProperties } from 'react';
import { Scrollbars as ReactCustomScrollbars } from 'react-custom-scrollbars';

export type ScrollbarPublicProps = {
  scrollTrackClass?: string;
  scrollThumbClass?: string;
  scrollContentsClass?: string;
  scrollMainClass?: string;
  hideX?: boolean;
  noMarginBottom?: boolean;
};

type ScrollbarsProps = {
  children: ReactNode;
} & ScrollbarPublicProps & { [key: string]: any };

const Scrollbars = ({
  children,
  forwardedRef,
  scrollTrackClass = 'scroll-track-vertical',
  scrollThumbClass = 'scroll-thumb-vertical',
  scrollContentsClass = 'scroll-contents',
  scrollMainClass = 'scroll-main',
  hideX = false,
  noMarginBottom = false,
  ...others
}: ScrollbarsProps & { forwardedRef: ForwardedRef<ReactCustomScrollbars> }) => {
  const additionalStyles: Partial<CSSProperties> = hideX ? { overflowX: 'hidden' } : {};

  return (
    <ReactCustomScrollbars
      renderTrackVertical={(props) => <div {...props} className={scrollTrackClass} />}
      renderThumbVertical={(props) => <div {...props} className={scrollThumbClass} />}
      renderView={(props: { style: CSSProperties }) => (
        <div
          {...props}
          className={scrollContentsClass}
          style={{ ...props.style, ...additionalStyles, marginBottom: noMarginBottom ? 0 : props.style.marginBottom }}
        />
      )}
      className={scrollMainClass}
      ref={forwardedRef}
      {...others}
    >
      {children}
    </ReactCustomScrollbars>
  );
};

const FwdScrollbars = forwardRef<ReactCustomScrollbars, ScrollbarsProps>((props, ref) => (
  <Scrollbars {...props} forwardedRef={ref} children={props.children} />
));

export default FwdScrollbars;
